/*
 * @Author: your name
 * @Date: 2022-10-26 08:53:01
 * @LastEditTime: 2023-05-31 09:24:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/services/packageManage.ts
 */
import request from 'root/utils/request';

const basePath = '/api/ops-manager/v2/supos';

// 获取安装包列表
export const getPacklistApi = async (type?: string) => {
  if (type) return request.get(`${basePath}/manager/packages/${type}`);
  return request.get(`${basePath}/manager/packages`);
};

// 根据条件查询获取安装包列表
export const queryPacklistApi = async (data: any) => {
  return request.post(`${basePath}/manager/packages`, data);
};

// 删除安装包
// export const deletePackApi = async (fileName: string, tasks?: [string][]) => {
//   return request({
//     method: 'post',
//     // url: `${basePath}/manager/packages/${fileName}`,
//     url: `/api/ops-manager/v2/supos/manager/packages/delete`,
//   });
// };

// 删除安装包
export const deletePackApi = async (params: any) => {
  return request.post(`/api/ops-manager/v2/supos/manager/packages/delete`, params);
};

// 获取单条包状态
export const getPackApi = async (archiveId: string) => {
  return request.get(`${basePath}/manager/packages/${archiveId}`);
};

// 检测扩展组件安装包
export const checkExtPackApi = async (params: any) => {
  return request.post(`${basePath}/manager/extensions/check`, params);
};

// 检测supos安装包
export const checkSupOSPackApi = async (data: any) => {
  return request.get(`${basePath}/manager/packages/check/${data}`);
};

// 获取安装列表
export const getExtendApi = async (data?: any) => {
  return request.post(`${basePath}/manager/extensions`, data);
};

// 获取系统扩展服务安装包
export const getSystemApi = async (type?: any) => {
  return request.post(`${basePath}/manager/upgrade`, type);
};

// 获取系统升级安装包
export const getExtendPackage = async (type?: any) => {
  return request.post(`${basePath}/manager/packages/operate`, type);
};

// 获取卷组信息
export const getDiskGroupApi = async () => {
  return request.get(`/api/ops-manager/v1/supos/disk/package/used`);
};

// 取消安装
export const cancelPakcApi = async (fileName: string) => {
  return request({
    method: 'delete',
    url: `${basePath}/manager/packages/cancel/${fileName}`,
  });
};

// 解压安装包
export const unzipPackApi = async (id: string) => {
  return request.get(`${basePath}/manager/packages/unzip/${id}`);
};

// 安装包协议
export const packAgreement = async (id: string) => {
  return request.get(`${basePath}/manager/packages/agree/${id}`);
};

// 查看是否有运行实例
export const getSuposInstanceApi = async () => {
  return request.get(`api/ops-manager/v1/supos/disk/home/check`);
};

// 安装包删除检查
export const deleteCheckApi = async (archiveId: string) => {
  return request.get(`api/ops-manager/v2/supos/manager/packages/check/${archiveId}`);
};

// 判断文件是否上传过，是否存在分片，断点续传
export const bigfileCheckApi = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/bigfile/check`, params);
};

// 分片上传
export const bigfileUpload = async (formData: FormData) => {
  return request.post(`/api/ops-manager/v1/supos/bigfile/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// 文件合并
export const bigfileMerge = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/bigfile/merge`, params);
};

// 文件取消上传
export const bigfileCancel = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/bigfile/cancel`, params);
};
// 获取无扰升级提示信息
export const getUpgradInfoApi = async (params: any) => {
  return request.post(`/api/ops-manager/v2/supos/manager/packages/update_note`, params);
};
